/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['jquery', 'underscore', 'assets/js/modules/widgets/mailingLists/model/mailingListModel', 'assets/js/modules/utils'], function(
    $,
    _,
    MailingListModel,
    utils
) {
    var MailingListItemCollection = function(initializedItems) {
        /**
         * @var {Array}
         */
        var items = initializedItems;

        /**
         * @return {Array}
         */
        this.getItems = function() {
            return items;
        };

        /**
         * @param {Object} item
         * @param {number} index
         */
        this.replace = function(item, index) {
            items.splice(index, 1, item);
        };

        /**
         * @param {Object} properties
         * @return {Array}
         */
        this.where = function(properties) {
            return _.where(items, properties);
        };

        /**
         *
         * @param {Object} properties
         * @return {Object}
         */
        this.findWhere = function(properties) {
            return _.findWhere(items, properties);
        };

        /**
         * @param {number} index
         * @return {Object}
         */
        this.at = function(index) {
            return items[index];
        };

        /**
         * @param {number} orderId
         * @return {Object}
         */
        this.get = function(orderId) {
            return _.findWhere(items, {
                orderId: orderId
            });
        };

        /**
         * @param {Object} item
         */
        this.add = function(item) {
            var existingItem = _.findWhere(items, item);
            if (existingItem === undefined) {
                items.push(item);
            }
        };

        /**
         * @param {Array} newItems
         */
        this.addAll = function(newItems) {
            var _this = this;

            newItems.forEach(function(item) {
                _this.add(item);
            });
        };

        /**
         * @param {Object} item
         * @return {number}
         */
        this.indexOf = function(item) {
            return _.indexOf(items, item);
        };

        /**
         * @return {number}
         */
        this.getLength = function() {
            return items.length;
        };

        /**
         * @param {number} newLength
         * @return {Deferred}
         */
        this.addDummiesAsync = function(newLength) {
            var _this = this;
            var d = $.Deferred();

            if (items.length >= newLength) {
                d.resolve();
            } else {
                var orderId = this.getNextOrderId();
                var addAsync = utils.iterateAsync(
                    items.length,
                    newLength,
                    function(i) {
                        var item = MailingListItemCollection.getDefaultItem({
                            orderId: orderId
                        });
                        orderId++;
                        _this.add(item);
                    },
                    500
                );

                addAsync.then(function() {
                    d.resolve();
                });
            }

            return d.promise();
        };

        /**
         * @return {number}
         */
        this.getNextOrderId = function() {
            if (items.length) {
                return (
                    _.max(items, function(item) {
                        return item['orderId'];
                    })['orderId'] + 1
                );
            }
            return 0;
        };

        /**
         * @param {boolean} considerId
         * @param {Object} clause
         * @return {Array}
         */
        this.filterNonEmpty = function(considerId, clause) {
            var _this = this;

            return _.filter(items, function(item) {
                var isFiltered = !MailingListItemCollection.isEmptyItem(item, considerId);
                _.each(clause, function(value, prop) {
                    isFiltered = isFiltered && item[prop] === value;
                });
                return isFiltered;
            });
        };

        /**
         * @param {boolean} considerId
         * @param {Object} clause
         * @return {Array}
         */
        this.filterEmpty = function(considerId, clause) {
            var _this = this;

            return _.filter(items, function(item) {
                var isFiltered = MailingListItemCollection.isEmptyItem(item, considerId);
                _.each(clause, function(value, prop) {
                    isFiltered = isFiltered && item[prop] === value;
                });
                return isFiltered;
            });
        };

        /**
         * @param {boolean} isLoaded
         */
        this.setLoaded = function(isLoaded) {
            items.forEach(function(item) {
                item['loaded'] = isLoaded;
            });
        };

        /**
         * @return {Array}
         */
        this.toDTO = function() {
            var dtos = [];

            items.forEach(function(item) {
                dtos.push(MailingListItemCollection.itemToDTO(item));
            });
            return dtos;
        };
    };

    /**
     * @param {Object} item
     * @param {Object} options
     * @return {Object}
     */
    MailingListItemCollection.itemFromDTO = function(item, options) {
        _.each(MailingListItemCollection.getDTOScheme(), function(mappedName, attributeName) {
            if (options[mappedName] !== undefined) {
                item[attributeName] = options[mappedName];
            }
        });

        return this;
    };

    /**
     * @return {Object}
     */
    MailingListItemCollection.getDTOScheme = function() {
        return {
            record: 'record',
            firstName: 'first_name',
            middleInitial: 'middle_initial',
            lastName: 'last_name',
            title: 'title',
            company: 'company',
            address: 'address',
            address2: 'address2',
            city: 'city',
            state: 'state',
            postalCode: 'postal_code'
        };
    };

    /**
     * @return {Object}
     */
    MailingListItemCollection.getDefaultItem = function(fields) {
        return _.extend(
            {
                record: null,
                title: null,
                firstName: null,
                middleInitial: null,
                lastName: null,
                company: null,
                address: null,
                address2: null,
                city: null,
                state: null,
                postalCode: null,

                orderId: null,
                selected: false,
                loaded: false
            },
            fields
        );
    };

    /**
     * @param {Object} item
     * @param {boolean} considerId
     * @return {boolean}
     */
    MailingListItemCollection.isEmptyItem = function(item, considerId) {
        var isEmpty = true;
        _.each(MailingListItemCollection.getDTOScheme(), function(value, key) {
            if (!considerId && key === 'record') {
                return;
            }
            if (item[key]) {
                isEmpty = false;
            }
        });
        return isEmpty;
    };

    /**
     * @param {Object} item
     * @return {Object}
     */
    MailingListItemCollection.itemToDTO = function(item) {
        var dto = {};
        var attribute;

        _.each(MailingListItemCollection.getDTOScheme(), function(mappedName, attributeName) {
            attribute = item[attributeName];
            if (attribute !== undefined) {
                if (attribute === '') {
                    attribute = null;
                }
                dto[mappedName] = attribute;
            }
        });

        return dto;
    };

    MailingListItemCollection.titles = {
        title: 'Prefix / Title',
        firstName: 'First Name',
        middleInitial: 'Middle Initial',
        lastName: 'Last Name',
        company: 'Company',
        address: 'Address 1',
        address2: 'Address 2',
        city: 'City',
        state: 'State',
        postalCode: 'Zip'
    };

    MailingListItemCollection.required = ['firstName', 'lastName', 'address', 'city', 'state', 'postalCode'];

    return MailingListItemCollection;
});
